import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Ensure this file exists and is used
import App from './App'; // Ensure App component is correctly imported
import reportWebVitals from './reportWebVitals'; // Ensure this file exists and is used

const root = ReactDOM.createRoot(document.getElementById('root')); // Create the root element for rendering
root.render(
  <React.StrictMode>
    <App /> {/* Render the App component inside StrictMode for additional checks */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); // Measure performance in your app (if needed)
